import { render, staticRenderFns } from "./RelocationLimitsPage.vue?vue&type=template&id=a22c915c&"
import script from "./RelocationLimitsPage.vue?vue&type=script&lang=ts&"
export * from "./RelocationLimitsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports